import React from "react";
import MobilePage from "./components/pageMobile";
import { Box, makeStyles } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { grey } from "@material-ui/core/colors";
import "./App.css";
import Page from "./components/page";
import { theme } from "./lib/constants";
import { useMobile } from "./helperFunctions";

const useStyles = makeStyles(
  () => ({
    box: {
      width: "100vw",
      height: "100vh",
      backgroundColor: grey[200]
    }
  }),
  { name: "App" }
);

function App() {
  const classes = useStyles();
  const isMobile = useMobile();

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.box}>{isMobile === true ? <MobilePage /> : <Page />}</Box>
    </ThemeProvider>
  );
}

export default App;
